import { Radio } from 'antd';
import classnames from 'classnames';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

const RadioGroup = Radio.Group;

const BaseRadioGroup_ = (props) => {
  const { field, radioAsBox, onBlur, handleChange, customKeys, options, ...rest } = props;

  const mappedOptions = (options, keys = { label: 'name', value: 'id' }) => {
    return options.map((o) => ({
      label: o[keys.label],
      value: o[keys.value],
    }));
  };

  return (
    <div data-testid={rest['data-testid']}>
      <RadioGroup
        className={classnames('base-radio', `base-radio--${props.name}`, {
          'base-radio-group--visual': radioAsBox,
        })}
        {...field}
        {...rest}
        onBlur={onBlur}
        options={customKeys ? mappedOptions(options, customKeys) : mappedOptions(options)}
        onChange={(e) => handleChange(e.target.value)}
      />
    </div>
  );
};

export const BaseRadioGroup = BaseFormFieldWrapper(BaseRadioGroup_);
export default BaseRadioGroup;
